import React from 'react'

export default function Control() {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.63281 52.8516H26.4844" stroke="url(#paint0_linear_3171_4095)" strokeOpacity="0.8" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M33.5156 52.8516H56.3672" stroke="url(#paint1_linear_3171_4095)" strokeOpacity="0.8" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M30 42.3047V49.3359" stroke="url(#paint2_linear_3171_4095)" strokeOpacity="0.8" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15.9375 3.63281H44.0625C44.0625 3.63281 47.5781 3.63281 47.5781 7.14844V24.7266C47.5781 24.7266 47.5781 28.2422 44.0625 28.2422H15.9375C15.9375 28.2422 12.4219 28.2422 12.4219 24.7266V7.14844C12.4219 7.14844 12.4219 3.63281 15.9375 3.63281Z" stroke="url(#paint3_linear_3171_4095)" strokeOpacity="0.8" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M30 28.2422V35.2734" stroke="url(#paint4_linear_3171_4095)" strokeOpacity="0.8" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M24.7266 35.2734H35.2734" stroke="url(#paint5_linear_3171_4095)" strokeOpacity="0.8" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.4219 20.0391H47.5781" stroke="url(#paint6_linear_3171_4095)" strokeOpacity="0.8" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M26.4844 52.8516C26.4844 53.7839 26.8547 54.6783 27.514 55.3376C28.1733 55.9969 29.0677 56.3672 30 56.3672C30.9323 56.3672 31.8267 55.9969 32.486 55.3376C33.1453 54.6783 33.5156 53.7839 33.5156 52.8516C33.5156 51.9192 33.1453 51.0248 32.486 50.3655C31.8267 49.7063 30.9323 49.3359 30 49.3359C29.0677 49.3359 28.1733 49.7063 27.514 50.3655C26.8547 51.0248 26.4844 51.9192 26.4844 52.8516Z" stroke="url(#paint7_linear_3171_4095)" strokeOpacity="0.8" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <linearGradient id="paint0_linear_3171_4095" x1="15.0586" y1="52.8516" x2="15.0586" y2="53.8516" gradientUnits="userSpaceOnUse">
          <stop stopColor="#232431" />
          <stop offset="0.335" stopColor="#3A3D54" />
        </linearGradient>
        <linearGradient id="paint1_linear_3171_4095" x1="44.9414" y1="52.8516" x2="44.9414" y2="53.8516" gradientUnits="userSpaceOnUse">
          <stop stopColor="#232431" />
          <stop offset="0.335" stopColor="#3A3D54" />
        </linearGradient>
        <linearGradient id="paint2_linear_3171_4095" x1="30.5" y1="42.3047" x2="30.5" y2="49.3359" gradientUnits="userSpaceOnUse">
          <stop stopColor="#232431" />
          <stop offset="0.335" stopColor="#3A3D54" />
        </linearGradient>
        <linearGradient id="paint3_linear_3171_4095" x1="30" y1="3.63281" x2="30" y2="28.2422" gradientUnits="userSpaceOnUse">
          <stop stopColor="#232431" />
          <stop offset="0.335" stopColor="#3A3D54" />
        </linearGradient>
        <linearGradient id="paint4_linear_3171_4095" x1="30.5" y1="28.2422" x2="30.5" y2="35.2734" gradientUnits="userSpaceOnUse">
          <stop stopColor="#232431" />
          <stop offset="0.335" stopColor="#3A3D54" />
        </linearGradient>
        <linearGradient id="paint5_linear_3171_4095" x1="30" y1="35.2734" x2="30" y2="36.2734" gradientUnits="userSpaceOnUse">
          <stop stopColor="#232431" />
          <stop offset="0.335" stopColor="#3A3D54" />
        </linearGradient>
        <linearGradient id="paint6_linear_3171_4095" x1="30" y1="20.0391" x2="30" y2="21.0391" gradientUnits="userSpaceOnUse">
          <stop stopColor="#232431" />
          <stop offset="0.335" stopColor="#3A3D54" />
        </linearGradient>
        <linearGradient id="paint7_linear_3171_4095" x1="30" y1="49.3359" x2="30" y2="56.3672" gradientUnits="userSpaceOnUse">
          <stop stopColor="#232431" />
          <stop offset="0.335" stopColor="#3A3D54" />
        </linearGradient>
      </defs>
    </svg>
  )
}
